import { useState } from "react";
import Button from "../Button/Button.jsx";
import Dialog from "../Dialog/Dialog.jsx";
import { Variants } from "../Button/Variants.jsx";
import { getConfirmAbortButtons } from "./ConfirmAbortButtons.jsx";

/**
 * Represents a confirmation component that displays a dialog to confirm an action.
 * The dialog includes customizable text, buttons, and a child node for additional content.
 * It is not always used for confirmation. Sometimes, a Dialog with just the same confirmAbortButtons is used.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {string} [props.title="Sicher?"] - The title of the confirmation dialog.
 * @param {string} [props.buttonText="Löschen"] - The text displayed on the button that opens the confirmation dialog.
 * @param {Function} props.onConfirm - A callback function invoked when the confirmation action is confirmed.
 * @param {string} [props.confirmLabel="Ja"] - The text displayed on the confirm button within the dialog.
 * @param {import("react").ReactNode} props.children - Additional content to display within the confirmation dialog.
 * @returns {import("react").ReactNode} A confirmation button and dialog component.
 */
export const Confirm = ({
  title = "Sicher?",
  buttonIcon = "bin",
  buttonText,
  onConfirm,
  confirmLabel = "Ja",
  children,
}) => {
  const [open, setOpen] = useState(false);
  function handleOpen() {
    setOpen(true);
  }

  return (
    <>
      <Button
        variant={Variants.TERTIARY}
        iconLeft={buttonIcon}
        onClick={handleOpen}
        width={"fit-content"}
      >
        {buttonText}
      </Button>
      <Dialog
        open={open}
        setOpen={setOpen}
        title={title}
        buttons={getConfirmAbortButtons(setOpen, onConfirm, confirmLabel)}
      >
        {children}
      </Dialog>
    </>
  );
};
